(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["awokee-footer"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('awokee-footer-state')) {
  class AwokeeFooterState extends HTMLElement {
    connectedCallback() {
      this.footer = this.closest('.shopify-section').querySelector('[data-aw-footer]');
      if (!this.footer) return;
      this.query = window.matchMedia('(max-width: 749px)');
      this.sync = () => {
        this.footer.querySelectorAll('.aw-footer__group').forEach((group) => {
          group.open = !this.query.matches;
          const summary = group.querySelector('summary');
          if (this.query.matches) summary.removeAttribute('tabindex');
          else summary.setAttribute('tabindex', '-1');
        });
      };
      this.sync();
      this.query.addEventListener('change', this.sync);
    }
    disconnectedCallback() {
      this.query?.removeEventListener('change', this.sync);
    }
  }
  customElements.define('awokee-footer-state', AwokeeFooterState);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["awokee-page"] && !Shopify.designMode) return;
  try {
    
function initializeAwokeeInquiry(scope) {
  scope.querySelectorAll('[data-aw-quote]').forEach((wrapper) => {
    if (wrapper.dataset.initialized) return;
    wrapper.dataset.initialized = 'true';
    const form = wrapper.querySelector('form');
    if (!form) return;
    const field = (name) => form.elements.namedItem('contact[' + name + ']');
    const type = field('Inquiry type'), product = field('Product'), quantity = field('Quantity');
    const hint = wrapper.querySelector('[data-aw-minimum]');
    const params = new URLSearchParams(location.search);
    const requestedType = params.get('inquiry'), requestedProduct = params.get('product');
    const design = field('Design inspiration');
    const customFields = wrapper.querySelector('[data-aw-custom-fields]');
    const requestedDesign = params.get('design');
    if (design && Array.from(design.options).some(option => option.value === requestedDesign)) design.value = requestedDesign;
    if (['wholesale','samples','customization','documentation'].includes(requestedType)) type.value = requestedType;
    if (requestedProduct && Array.from(product.options).some(option => option.value === requestedProduct)) product.value = requestedProduct;
    const syncType = () => {
      if (customFields) {
        customFields.hidden = type.value !== 'customization';
        customFields.querySelectorAll('input, select').forEach(input => { input.disabled = customFields.hidden; });
      }
      const sample = type.value === 'samples', docs = type.value === 'documentation', multiple = product.value === 'multiple';
      quantity.min = sample || docs || multiple ? '1' : '5000';
      quantity.required = !docs && !multiple;
      quantity.setCustomValidity('');
      hint.textContent = docs ? hint.dataset.documentation : sample ? hint.dataset.sample : multiple ? hint.dataset.multiple : hint.dataset.wholesale;
    };
    syncType(); type.addEventListener('change', syncType); product.addEventListener('change', syncType);
    quantity.addEventListener('input', () => quantity.setCustomValidity(''));
    quantity.addEventListener('invalid', () => { if (quantity.validity.rangeUnderflow && quantity.min === '5000') quantity.setCustomValidity(hint.dataset.invalid); });
  });
  scope.querySelectorAll('[data-aw-print]').forEach((button) => {
    if (button.dataset.initialized) return;
    button.dataset.initialized = 'true'; button.addEventListener('click', () => window.print());
  });
}
initializeAwokeeInquiry(document);
document.addEventListener('shopify:section:load', (event) => initializeAwokeeInquiry(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
